<template>
    <div id="CustomerPurchaseOrderView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Part Order View</div>
                    <!-- <router-link class="btn btn-secondary pull-right" v-bind:to="{name: 'PurchaseOrderAllList',query: { from: 'customer' }}" >
                        <i class="fp-back"></i>  Back
                    </router-link> -->
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backBtn()" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-po-view list-view">
                        <div id="tabs" class="containerTab">
                            <div class="tabs">
                                <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Customer Purchse Order Details</a>
                                <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity Log</a>
                            </div>
                            <div class="content">
                                <div v-show="activetab === 1" class="tabcontent">
                                    <div class="list-sections">
                                        <div class="form-row no-divider">
                                            <div class="col-md-4">
                                                <div class="row form-group">
                                                    <label class="col">Purchase Order Number:</label>
                                                    <span class="col">{{poNum}}</span>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col">Purchase Order Type:</label>
                                                    <span class="col">{{titleCase(po_type)}}</span>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col">Customer:</label>
                                                    <span class="col">{{customer}}</span>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col">Amount:</label>
                                                    <span class="col">${{amountFormat(amount)}}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="row form-group">
                                                    <label class="col">Ordering:</label>
                                                    <span class="col">{{orderingLoc}}</span>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col">Assigned:</label>
                                                    <span class="col">{{assignLoc}}</span>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col">Ship To:</label>
                                                    <span class="col">{{shipToLoc}}</span>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col">Status:</label>
                                                    <span class="col">{{titleCase(status)}}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-4" v-if="po_type != 'contract'">
                                                <div class="row form-group">
                                                    <label class="col">Order Date:</label>
                                                    <span class="col">{{order_date}}</span>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col">Due Date:</label>
                                                    <span class="col">{{due_date}}</span>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col">Delivery Date:</label>
                                                    <span class="col">{{delivery_date}}</span>
                                                </div>
                                            </div>
                                            <div class="col-md-4" v-else>
                                                <div class="row form-group">
                                                    <label class="col">Effective From:</label>
                                                    <span class="col">{{effective_from}}</span>
                                                </div>
                                                <div class="row form-group">
                                                    <label class="col">Effective To:</label>
                                                    <span class="col">{{effective_to}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="btn-groups mt-4">
                                            <button type="submit" id="editWorkOrderEstimateBtn" v-on:click="editCustomerPurchaseOrder()" class="btn btn-primary" ><i class="fp-edit-icon"></i>  Edit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                                    <estimate-activity-log-list :activityLogVal="activityLogsTabValue"></estimate-activity-log-list>
                                </div>
                            </div>
                        </div>
                        <template v-if="activetab === 1">
                            <div class="policy-attachment mt-4 clear">
                                <h5 class="color-darkblue"> Attachments </h5>
                                <div class="bg-white">
                                    <template v-if="files.length > 0">
                                        <template v-for="(doc,vkey) in files">
                                            <div v-bind:key="'fileDiv'+vkey" class="attachment-list">
                                                <i v-if="doc.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                <i v-if="doc.extension == 'doc' || doc.extension == 'docs'" class="fp-text-document"></i>
                                                <i v-if="doc.extension == 'jpg' ||  doc.extension == 'png' ||  doc.extension == 'jpeg' " class="fp-image"></i>
                                                <a :key="vkey" href="javascript:void(0)" class="customer-detail-rv" v-on:click="openDocument(doc.url,doc.extension)">  {{doc.file_name}}</a>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <span>No attachments found.</span>
                                    </template>
                                </div>
                            </div>
                            <section class="bg-white mt-4">
                                <template v-if="purchaseOrderItemsArr.length == 0">
                                    <div class="lineitem-main-section">
                                        <h2>No Line Item Added</h2>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="table-responsive-sm">
                                        <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm font-1 purchase-order-item-table" v-if="purchaseOrderItemsArr != undefined && purchaseOrderItemsArr.length > 0">
                                            <thead class="table table-bordered table-sm">
                                                <tr class="table-primary">
                                                    <th v-if="!showItemsColumn">Manufacturer</th>
                                                    <th v-if="!showItemsColumn">Asset Model</th>
                                                    <th v-if="!showItemsColumn">Asset Pool</th>
                                                    <th v-if="!showItemsColumn">Year</th>
                                                    <th v-if="showItemsColumn">Part</th>
                                                    <th v-if="showItemsColumn">Description</th>
                                                    <th class="text-right">Quantity</th>
                                                    <th class="text-right" v-if="!showContractColumn">Unit Price</th>
                                                    <th class="text-right" v-if="!showContractColumn">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in purchaseOrderItemsArr" v-bind:key="index">
                                                    <td v-if="!showItemsColumn"> {{ item.manufacture_id.text}} </td>
                                                    <td v-if="!showItemsColumn"> {{ item.model_id.text}} </td>
                                                    <td v-if="!showItemsColumn"> {{ item.asset_pool_id.text}} </td>
                                                    <td v-if="!showItemsColumn"> {{ item.year}} </td>
                                                    <td v-if="showItemsColumn"> {{ item.part.text}} </td>
                                                    <td v-if="showItemsColumn"> {{ item.description}} </td>
                                                    <td class="text-right"> {{ item.quantity}} </td>
                                                    <td class="text-right" v-if="!showContractColumn"> ${{ amountFormat(item.unit_price)}} </td>
                                                    <td class="text-right" v-if="!showContractColumn"> ${{ amountFormat(item.total)}} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </template>
                            </section>
                            <div class="order-summary mt-4">
                                <div class="row">
                                    <div class="col-md-4 offset-md-8">
                                        <div class="bg-white radius-5 p-3">
                                            <label> SUMMARY </label>
                                            <table aria-describedby="table" class="table table-sm table-bordered">
                                                <tbody>
                                                    <tr>
                                                        <td>Unit Price:</td>
                                                        <td class="text-right">${{amountFormat(subTotal)}}</td>
                                                    </tr>
                                                    <tr class="table-secondary">
                                                        <td>Total:</td>
                                                        <td class="order-total text-right">${{amountFormat(total)}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import ActivityLogListView from '@/components/ActivityLogList.vue';

Vue.component("estimate-activity-log-list", ActivityLogListView);


export default {
    name: "CustomerPurchaseOrderView",

    mixins:[commonMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        showItemsColumn:true,
        loading:false,
        poNum:"",
        vendor:"",
        orderingLoc:"",
        assignLoc:"",
        shipToLoc:"",
        delivery_date:"",
        order_date:"",
        due_date:"",
        po_type:"",
        customer:"",
        amount:0,
        status:"",
        attention:"",
        sales_person:"",
        notes:"",
        subTotal:0,
        totalTax:0,
        total:0,
        files:[],
        purchaseOrderItemsArr:[],
        activetab: 1,
        activityLogsTabValue: "dontLoadList",
        activityLoaded:false,
        effective_from:'',
        effective_to:'',
        showContractColumn:false,
        velocity_env:process.env.NODE_ENV,
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (self.velocity_env == "velev" || self.velocity_env == "velev_test") {
                        if (permissions[i].name == 'ev_view_part_order') {
                            self.cantAccessPage = true;
                        }
                    }else{
                        if (permissions[i].name == 'view_customer_purchase_order') {
                            self.cantAccessPage = true;
                        }
                    }
                }
            }

        },
    },
    created: function() {

    },
    mounted: function() {
        var self = this;

        self.getPermissions();
        self.loadCustomerPurchaseOrder();
    },
    metaInfo() {
        return {
            title: (this.poNum != "") ? this.poNum + " | Part Order View | " +process.env.COPYRIGHT_NAME:"Part Order View | " +process.env.COPYRIGHT_NAME
        }
    },
    methods: {
        editCustomerPurchaseOrder(){
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.$router.push("/part-order/edit/" + segments[3]);
        },
        loadCustomerPurchaseOrder() {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/customer-purchase-order/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {

                       self.poNum = data.content.po_no;
                       self.po_type = data.content.type;
                       if(data.content.type == "item"){
                            self.showItemsColumn = true;
                       }else{
                           self.showItemsColumn = false;
                       }
                       if(data.content.type == "contract"){
                            self.showContractColumn = true;
                       }else{
                           self.showContractColumn = false;
                       }
                       if(data.content.cust_name != null){
                            self.customer = data.content.cust_code +" | "+ data.content.cust_name;
                        }else{
                            self.customer = "-"
                        }

                        if(data.content.ordering_loc_name != null){
                            self.orderingLoc = data.content.ordering_loc_name +" ("+ data.content.ordering_loc_code +")";
                        }else{
                            self.orderingLoc = "-";
                        }

                        if(data.content.assigned_loc_name != null){
                            self.assignLoc = data.content.assigned_loc_name +" ("+ data.content.assigned_loc_code +")";
                        }else{
                            self.assignLoc = "-";
                        }

                        if(data.content.ship_loc_name != null){
                            self.shipToLoc = data.content.ship_loc_name +" ("+ data.content.ship_loc_code +")";
                        }else{
                            self.shipToLoc = "-";
                        }

                        if(data.content.delivery_date != null){
                            self.delivery_date = data.content.delivery_date;
                        }else{
                            self.delivery_date = "-";
                        }

                        if(data.content.attention != null){
                            self.attention = data.content.attention;
                        }else{
                            self.attention = "-";
                        }

                        if(data.content.notes != null){
                            self.notes = data.content.notes;
                        }else{
                            self.notes = "-";
                        }

                        if(data.content.sales_firstname != null){
                            self.sales_person = self.titleCase(data.content.sales_firstname + " " + data.content.sales_lastname);
                        }else{
                            self.sales_person = "-";
                        }

                        if(data.content.type == "contract"){
                            self.effective_from = data.content.effective_from;
                            self.effective_to = data.content.effective_to;
                        }else{
                            self.order_date = data.content.order_date;
                            self.due_date = data.content.due_date;
                        }
                        self.amount = data.content.amount;
                        self.status = data.content.status;
                        if(data.content.doc_path != null){
                            self.files = data.content.doc_path;
                        }
                        self.subTotal = data.content.sub_total;
                        self.totalTax = data.content.total_tax;
                        self.total = data.content.total;
                        self.loadCustomerPurchaseOrderItem();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'customer-po-view');
                }
            });
        },
        loadCustomerPurchaseOrderItem(){
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/customer-purchase-order/item/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);

                    if (data.status == "success") {

                        self.purchaseOrderItemsArr = [];
                        if(data.content.length>=1) {
                            for (var i = 0; i < data.content.length; i++) {

                                self.purchaseOrderItemsArr.push({
                                    purchase_order_item_id: data.content[i].id,
                                    purchase_order_id: data.content[i].purchase_order_id,
                                    description:data.content[i].part_description,
                                    manufacture_id: (data.content[i].manufacture_id != undefined && data.content[i].manufacture_id != null && data.content[i].manufacture_id != '')?{value: data.content[i].manufacture_id, text: self.titleCase(data.content[i].vmCode + " | " + data.content[i].vmName)}:"-",
                                    model_id: (data.content[i].model_id != undefined && data.content[i].model_id != null && data.content[i].model_id != '')?{value: data.content[i].model_id, text: self.titleCase(data.content[i].vmodelsCode + " | " + data.content[i].vmodelsName)}:"-",
                                    part: (data.content[i].item_id != undefined && data.content[i].item_id != null && data.content[i].item_id != '')?{value: data.content[i].item_id, text: self.titleCase(data.content[i].iCode + " (" + data.content[i].iName+")")}:"-",
                                    year: (data.content[i].year != undefined && data.content[i].year != null && data.content[i].year != '')?data.content[i].year:"-",
                                    quantity: data.content[i].quantity,
                                    asset_pool_id: (data.content[i].asset_pool_id != undefined && data.content[i].asset_pool_id != null && data.content[i].asset_pool_id != '')?{value: data.content[i].item_id, text: self.titleCase(data.content[i].vpoolCode + " | " + data.content[i].vpoolDesc)}:"-",
                                    unit_price: data.content[i].unit_price,
                                    tax_percentage: data.content[i].tax_percentage,
                                    tax_amount: data.content[i].tax_amount,
                                    sub_total: data.content[i].sub_total,
                                    total: data.content[i].total,
                                })
                            }
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'customer-po-items-view');
                }
            });
        },
        titleCase(str) {
            if ( str == null ) {
                return "-";
            } else {
                var value = str.toString();
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        },
      activityLogs(){

        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");

        self.$root.$emit('activity_log_opted','customer purchase order',segments[3]);
        self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
        self.activetab = 2;
      },
      backBtn() {
          var self = this;
          var url = "/order-history/list"
          if ( self.$route.query.fromUrl != "" && self.$route.query.fromUrl != undefined ) {
              url = atob(self.$route.query.fromUrl);
          }
          self.redirectPageUrl(url);
      },

    }


}
</script>




// WEBPACK FOOTER //
// src/components/CustomerPurchaseOrderView.vue